"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if a given value is an array.
 *
 * @param {unknown} value - The value to check.
 * @returns {boolean} True if the value is an array, false otherwise.
 */
function isArray(value) {
    return Array.isArray(value);
}
exports.default = isArray;
//# sourceMappingURL=is-array.js.map